var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinkArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.39722,
    cy: 8,
    r: 8,
    fill: "#A93E71"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5165 3.9262L5.65624 7.78653C5.56704 7.87574 5.51807 7.99467 5.51807 8.12425C5.51807 8.25122 5.56704 8.37023 5.65624 8.45929L9.51284 12.316C9.60211 12.4052 9.72112 12.4543 9.84809 12.4543C9.97506 12.4543 10.0941 12.4053 10.1833 12.316L10.4674 12.032C10.5566 11.9428 10.6058 11.8237 10.6058 11.6968C10.6058 11.5698 10.5566 11.4508 10.4674 11.3615L7.22878 8.12291L10.4711 4.88073C10.5602 4.79153 10.6094 4.67252 10.6094 4.54548C10.6094 4.41851 10.5602 4.29957 10.4711 4.2103L10.1869 3.9262C10.0021 3.74145 9.70132 3.74145 9.5165 3.9262Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkArrowRight);
export default __webpack_public_path__ + "static/media/pink-arrow-right.a2650fdcee519ddf998d1f49f333b776.svg";
export { ForwardRef as ReactComponent };